import CodeEditor from './CodeEditor';

const labelForChunk = (chunk) => {
  if (!chunk) return 'Chunk';
  const coords = `(${chunk.x}, ${chunk.z})`;
  if (!chunk.offset) return `${chunk.index ?? 0} ${coords} (empty)`;
  return `${chunk.index ?? 0} ${coords}`;
};

const NbtEditorModal = ({ state, onClose, onSave, onChangeText, onSelectChunk }) => {
  if (!state) return null;
  const { path, text, mode, chunks = [], selectedChunk, loadingChunk, dirty } = state;
  const chunk = chunks.find((c) => c.index === selectedChunk);

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 flex items-center justify-center p-4">
      <div className="bg-surface rounded-2xl shadow-2xl w-full max-w-5xl max-h-[90vh] flex flex-col gap-4 p-6 border border-border/50">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="space-y-1">
            <p className="text-xs font-semibold text-textMuted">NBT editor</p>
            <p className="text-sm text-textPrimary/80 break-all">{path}</p>
            <p className="text-xs text-textMuted">
              {mode === 'mca' ?
              'Region file (.mca). Select a chunk, edit JSON, then save to write back.' :
              'NBT (.dat) file. Edit JSON and save to write back.'}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button type="button" className="ghost-button" onClick={onClose}>
              Close
            </button>
            <button
              type="button"
              className="primary-button"
              onClick={onSave}
              disabled={loadingChunk}>
              
              {loadingChunk ? 'Loading...' : dirty ? 'Save changes' : 'Save'}
            </button>
          </div>
        </div>

        {mode === 'mca' &&
        <div className="flex flex-wrap items-center gap-3">
            <label className="text-xs text-textMuted">Chunk</label>
            <select
            className="input bg-surfaceHover"
            value={selectedChunk ?? ''}
            onChange={(e) => onSelectChunk(Number(e.target.value))}>
            
              {chunks.map((c) =>
            <option key={c.index} value={c.index}>
                  {labelForChunk(c)}
                </option>
            )}
            </select>
            {chunk &&
          <p className="text-xs text-textMuted">
                Offset {chunk.offset || 0} Sectors {chunk.sectors || 0}
              </p>
          }
          </div>
        }

        <div className="flex-1 min-h-[360px] h-[520px] bg-surfaceHover rounded-xl border border-border/50 p-2 overflow-hidden">
          <CodeEditor
            value={text || ''}
            language="json"
            wrap
            onChange={(val) => onChangeText(val)} />
          
        </div>
      </div>
    </div>);

};

export default NbtEditorModal;